import {useCallback,useMemo} from 'react';
import {Stack} from '@mui/material';
import COMPONENT_MAP from './Repository/Components.js';
import ErrorLogsPopup from './ErrorLog/ErrorLogsPopup.js';

const RecordInfo=({popupCallBack,rowId,singleFields,userData,application,entityType,errorLog})=>{
    const pageCallback=async({action,args})=>{
        if(action==='close_popup'){
            popupCallBack({action:'close_record_info'});
            return;
        }
    }
    const renderSingleField=useCallback((fieldName)=>{
        const Component=COMPONENT_MAP[singleFields[fieldName]?.ui_render_component];
        return Component?(
            <Component
                key={fieldName}
                row={singleFields}
                fieldName={fieldName}
                application={application}
                rowRules={null}
                readOnly={true}
                setFieldChanged={null}
                setFieldValue={null}
            />
        ):null;
    },[singleFields,application]);

    const renderFields=useCallback(()=>{
        return (
            <>
            <Stack key={'line_1'} direction={{xs:'column',sm:'row'}} spacing={{xs:1,sm:2,md:2}} sx={{mb:1}}>
                {renderSingleField('id')}
                {renderSingleField('created_by')}
                {renderSingleField('created_at')}
            </Stack>
            <Stack key={'line_2'} direction={{xs:'column',sm:'row'}} spacing={{xs:1,sm:2,md:2}} sx={{mb:1}}>
                {renderSingleField('reference')}
                {renderSingleField('updated_by')}
                {renderSingleField('updated_at')}
            </Stack>
            {errorLog&&<ErrorLogsPopup userData={userData} application={application} parent={{rowId,entityType}}/>}
            </>);
        },[renderSingleField,application,entityType,errorLog,rowId,userData]);
    
    const componentBody=useMemo(()=>renderFields(),[renderFields]);

    const renderDetailFormPopup=()=>{
        const Component=COMPONENT_MAP['DetailFormPopup'];
        return Component?(
            <Component
                key={'DetailFormPopup'}
                title={application.getLocale("ButtonRecordInfo")}
                application={application}
                handleClickEvent={pageCallback}
                isChanged={false}
                componentBody={componentBody}
                readOnly={true}
                recordRules={null}
                fromPopup={false}
                openOnUpdate={false}
            />
        ):null; 
    };

    return (renderDetailFormPopup());
}

export default RecordInfo;
